"use client";
import { IAccountAssets, IBlocks, IUserData } from "@/types";
import React from "react";
import type { BlockUpdateFunction } from "./utils/blocks-map";
import AdminPopover from "./utils/AdminPopover";
import BlockClickHandler from "./utils/click";
import { cn } from "@/lib/utils";
import {
    BORDER_RADIUS_OPTIONS,
    SHADOW_OPTIONS,
} from "./utils/block-style-classes";

interface Props {
    edit?: boolean;
    account: IUserData;
    block: IBlocks;
    update?: BlockUpdateFunction;
    assets: IAccountAssets[];
    theme: IUserData["chosen_theme"];
}
export default function BlockImage({
    edit,
    account,
    block,
    update,
    assets,
    theme,
}: Props) {
    const [blockUpdate, setBlockUpdate] = React.useState(block);
    let size = "w-full";
    if (blockUpdate.options?.size == 20) {
        size = "w-1/6";
    }
    if (blockUpdate.options?.size == 40) {
        size = "w-2/6";
    }
    if (blockUpdate.options?.size == 60) {
        size = "w-4/6";
    }
    if (blockUpdate.options?.size == 80) {
        size = "w-5/6";
    }
    if (blockUpdate.options?.size == 100) {
        size = "w-full";
    }
    const image_id =
        typeof blockUpdate.url == "string"
            ? blockUpdate.url.split("/").pop()?.split(".")[0]
            : null;
    const image_name = assets.find(
        (asset) => asset.url.split("/").pop()?.split(".")[0] == image_id
    )?.title;
    if (blockUpdate.options?.link?.length != 0) {
        return (
            <AdminPopover
                edit={edit}
                className={block.show ? "" : "opacity-30"}
                title={`Image - ${image_name}`}
                block={block}
                update={update}
                setBlockUpdate={setBlockUpdate}
            >
                <a
                    target="_blank"
                    href={blockUpdate.options?.link}
                    className={cn("w-full", "block-" + block.id)}
                    onClick={(e) => {
                        BlockClickHandler(account, e, block);
                    }}
                    onAuxClick={(e) => {
                        BlockClickHandler(account, e, block);
                    }}
                >
                    <img
                        id="uploaded-image"
                        src={blockUpdate.url}
                        className={cn(
                            `mx-auto rounded-xl  ${size}`,
                            BORDER_RADIUS_OPTIONS[
                                theme.profile.design.corner_radius
                            ]?.class,
                            SHADOW_OPTIONS[theme.profile.design.shadow]?.class,
                            blockUpdate.style?.custom &&
                                BORDER_RADIUS_OPTIONS[
                                    blockUpdate.style.corner_radius
                                ]?.class,
                            blockUpdate.style?.custom &&
                                SHADOW_OPTIONS[blockUpdate.style.shadow]?.class
                        )}
                        alt={blockUpdate.name}
                    />
                </a>
            </AdminPopover>
        );
    }
    return (
        <AdminPopover
            edit={edit}
            className={block.show ? "" : "opacity-30"}
            title={`Image - ${image_name}`}
            block={block}
            update={update}
            setBlockUpdate={setBlockUpdate}
        >
            <img
                id="uploaded-image"
                src={blockUpdate.url}
                className={cn(
                    `mx-auto rounded-xl  ${size}`,
                    BORDER_RADIUS_OPTIONS[theme.profile.design.corner_radius]
                        ?.class,
                    SHADOW_OPTIONS[theme.profile.design.shadow]?.class,
                    blockUpdate.style?.custom &&
                        BORDER_RADIUS_OPTIONS[blockUpdate.style.corner_radius]
                            ?.class,
                    blockUpdate.style?.custom &&
                        SHADOW_OPTIONS[blockUpdate.style.shadow]?.class,
                    "block-" + block.id
                )}
                alt={blockUpdate.name}
            />
        </AdminPopover>
    );
}
